import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  tableWrapper: {
    '& tr:nth-last-child(2):not(.expanded) td:first-child': {
      borderBottomLeftRadius: 0,
    },
    '& tr:nth-last-child(2):not(.expanded) td:last-child': {
      borderBottomRightRadius: 0,
    },
  },
}));

export default useStyles;
